import React, { useCallback } from 'react';

import { ccassService } from '../../../services';
import CCASSHistory, { CCASSHistoryProps } from './CCASSHistory';

const CCASSStockHistory: React.FC<
  Omit<CCASSHistoryProps, 'requestFn'>
> = props => {
  const requestFn = useCallback(() => {
    return ccassService.summaryHistory(
      undefined,
      `hk.${Number.parseInt(props.stockCode)}`
    );
  }, [props.stockCode]);

  return <CCASSHistory {...props} requestFn={requestFn} />;
};

export default CCASSStockHistory;
